"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SignInOrSignUpPageUI = _interopRequireDefault(require("../../03_organisms/SignInOrSignUpPageUI"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LoginPageUI = function LoginPageUI(_ref) {
  var error = _ref.error,
      email = _ref.email,
      password = _ref.password,
      _ref$onEmailChange = _ref.onEmailChange,
      onEmailChange = _ref$onEmailChange === void 0 ? function () {} : _ref$onEmailChange,
      _ref$onPasswordChange = _ref.onPasswordChange,
      onPasswordChange = _ref$onPasswordChange === void 0 ? function () {} : _ref$onPasswordChange,
      _ref$onSubmit = _ref.onSubmit,
      onSubmit = _ref$onSubmit === void 0 ? function () {} : _ref$onSubmit,
      _ref$onFacebookSignIn = _ref.onFacebookSignIn,
      onFacebookSignIn = _ref$onFacebookSignIn === void 0 ? function () {} : _ref$onFacebookSignIn,
      _ref$onGoogleSignIn = _ref.onGoogleSignIn,
      onGoogleSignIn = _ref$onGoogleSignIn === void 0 ? function () {} : _ref$onGoogleSignIn,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack,
      translatorForNamespace = _ref.translatorForNamespace;
  var t = translatorForNamespace('LoginPageUI');
  return /*#__PURE__*/_react["default"].createElement(_SignInOrSignUpPageUI["default"], {
    error: error,
    email: email,
    password: password,
    onEmailChange: onEmailChange,
    onPasswordChange: onPasswordChange,
    onSubmit: onSubmit,
    onFacebookSignIn: onFacebookSignIn,
    onGoogleSignIn: onGoogleSignIn,
    title: t('Login'),
    dividerText: t('or login with'),
    onBack: onBack,
    translatorForNamespace: translatorForNamespace
  });
};

var _default = LoginPageUI;
exports["default"] = _default;